const jquery = $;

const handleUpdateElement = ($tab, $formId, $path, pattern) => {
  const $elements = $formId
    ? $tab.find(`[data-form-item-id="${$formId}"]`)
    : $tab.find(`[data-composition-image-pattern]`);

  $elements.each(function () {
    const $element = $(this);
    const imagePattern = $(this).attr('data-composition-image-pattern');

    if (!$formId && false === pattern.includes(imagePattern)) return;

    $element.find('[data-modal-type="path"]').val($path);
    $element.find('[data-modal-type="image"]').attr('src', $path).removeClass('hidden');
    $element.find('[data-button-action="remove"]').removeAttr('disabled');
  })
}

$.fn.extend({
  handleSelectProductCompositionImageInFileManager() {
    $('[data-modal-type="product_compositions_images_file_manager_frame"]').on('load', function () {
      const $this = $(this);
      const $frame = $(this).contents();

      $(this).contents()
        .on('click', '.select', function () {
          const $modal = $('[data-modal-type="product_compositions_images_file_manager"]');
          const $tab = $('[data-tab="compositions"]')

          const $path = $(this).attr('data-path');
          const $formId = $this.attr('data-form-id');

          const pattern = decodeURI($path.split('/').pop().split('.').shift())

          handleUpdateElement($tab, $formId, $path, pattern);

          $modal.modal('hide');
        })
        .on('click', '#js-add-multiple', function () {
          const $modal = $('[data-modal-type="product_compositions_images_file_manager"]');
          const $tab = $('[data-tab="compositions"]')

          const $formId = $this.attr('data-form-id');
          const $children = $frame.find('.checkbox:checked');

          $children.each(function () {
            $(this).prop('checked', false);

            const $value = $(this).val();
            const $path = $frame.find(`[data-value="${$value}"]`).attr('data-path');

            if (!$path) return;

            const pattern = decodeURI($value.split('.').shift())

            handleUpdateElement($tab, $formId, $path, pattern);
          })

          $frame.find('#select-all').prop('checked', false);
          $modal.modal('hide');
        })
    });
  },
  handleOpenProductCompositionImagesModal(parent) {
    $('[data-button-action="open-product-compositions-images-modal"]').click(function () {
      const $fileManagerFrame = $('[data-modal-type="product_compositions_images_file_manager_frame"]')
      const $formId = $(this).attr('data-form-id')

      $formId
        ? $fileManagerFrame.attr('data-form-id', $formId)
        : $fileManagerFrame.removeAttr('data-form-id')

      const $modalKey = `[data-modal-type="product_compositions_images_file_manager"]`;

      if ($($modalKey).length > 1) {
        $(`.transition${$modalKey}`).remove()
      }

      const $modal = $('[data-modal-type="product_compositions_images_file_manager"]');

      if (parent) {
        $modal.modal({
          onHidden: function () {
            parent.modal('show');
          }
        });
      }

      $modal.modal('show');
    })
  },
  handleRemoveProductCompositionImage() {
    const $tab = $('[data-tab="compositions"]');
    const $removeButton = $tab.find('[data-button-action="remove"]');

    $removeButton.on('click', function () {
      const $formId = $(this).attr('data-form-id');

      const $element = $tab.find(`[data-form-item-id="${$formId}"]`);

      $element.find('[data-modal-type="path"]').val(null);
      $element.find('[data-modal-type="image"]').attr('src', null).addClass('hidden');
      $element.find('[data-button-action="remove"]').attr('disabled', true);
    })
  },
  handleSetDefaultInput(root) {
    $(root).on('change', 'input[type="checkbox"][data-form-type="choice-one"]', function (event) {
      const $target = $(event.target)
      const checked = $target.prop('checked')

      $(root).find('input[type="checkbox"][data-form-type="choice-one"]').prop('checked', false)

      $target.prop('checked', checked)
    })
  }
})

jquery(document).ready(() => {
  jquery(document).handleSetDefaultInput('#app_product_composition_values');

  jquery(document).handleSelectProductCompositionImageInFileManager();
  jquery(document).handleOpenProductCompositionImagesModal();
  jquery(document).handleRemoveProductCompositionImage();
});
